import { render, staticRenderFns } from "./system-user.vue?vue&type=template&id=4e83ccae&scoped=true"
import script from "./system-user.vue?vue&type=script&lang=js"
export * from "./system-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83ccae",
  null
  
)

export default component.exports